module.exports = __webpack_public_path__ + "img/Agents.97307fe.png";